import type { ReminderEntityConfig } from "web_myplann/Reminders/Config/reminderEntityConfig";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";
import { getSelectableTemplates } from "web_myplann/Reminders/Utils/getSelectableTemplates";

export const hasSelectableTemplates = (
	templates: ReminderTemplate[],
	entityConfig: ReminderEntityConfig,
	validTo: Date | null | undefined,
	today?: Date,
): boolean =>
	getSelectableTemplates(templates, entityConfig, validTo, today).length > 0;
